"use strict";
/** @jsxRuntime classic */
/** @jsx jsx */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArticleBase = exports.ArticlePosition = exports.articleOverlap = exports.articleReducedWidth = exports.articleDefaultWidth = exports.TEST_ID_ARTICLE = void 0;
var theme_ui_1 = require("theme-ui");
var theme_1 = require("../../../theme");
var jangle_1 = require("../../styles/Jangle/jangle");
exports.TEST_ID_ARTICLE = "article";
var height = 140;
var width = 350;
var reducedWidth = Math.round(width * 0.9);
var triSide = Math.round(Math.tan(jangle_1.JANGLE_RADIANS) * height);
var extraPercent = triSide / width * 100;
var reducedExtraPercent = triSide / reducedWidth * 100;
var transformHorizontal = theme_1.theme.space[1];
exports.articleDefaultWidth = transformHorizontal + width;
exports.articleReducedWidth = reducedWidth + transformHorizontal;
exports.articleOverlap = triSide - theme_1.theme.space[2];
var transformVertical = theme_1.theme.space[3];
var ArticlePosition;
(function (ArticlePosition) {
    ArticlePosition["START"] = "start";
    ArticlePosition["MIDDLE"] = "middle";
    ArticlePosition["END"] = "end";
})(ArticlePosition = exports.ArticlePosition || (exports.ArticlePosition = {}));
var articleStyleLookup = (_a = {},
    _a[ArticlePosition.START] = {
        clipPath: "polygon(0% 100%, 0% 0%, 100% 0%, " + (100 - reducedExtraPercent) + "% 100%)",
        width: exports.articleReducedWidth + "px",
        "& > div": {
            pl: 4,
            pr: 7,
            width: reducedWidth + "px"
        }
    },
    _a[ArticlePosition.MIDDLE] = {
        clipPath: "polygon(0% 100%, " + extraPercent + "% 0%, 100% 0%, " + (100 - extraPercent) + "% 100%)",
        width: exports.articleDefaultWidth + "px"
    },
    _a[ArticlePosition.END] = {
        clipPath: "polygon(0% 100%, " + reducedExtraPercent + "% 0%, 100% 0%, 100% 100%)",
        mr: 0,
        width: exports.articleReducedWidth + "px",
        "& > div": {
            pl: 7,
            pr: 4,
            width: reducedWidth + "px"
        }
    },
    _a);
function ArticleBase(_a) {
    var onClick = _a.onClick, children = _a.children, backgroundImage = _a.backgroundImage, backgroundColor = _a.backgroundColor, _b = _a.includeGradient, includeGradient = _b === void 0 ? true : _b, _c = _a.articlePosition, articlePosition = _c === void 0 ? ArticlePosition.MIDDLE : _c, csx = _a.csx;
    var backgroundGradientCSS = includeGradient ? "linear-gradient(180deg, rgba(0, 0, 0, 0) 40.34%, #000000 100%), " : "";
    var backgroundColorCSS = backgroundColor ? backgroundColor + " " : "";
    var backgroundImageCSS = backgroundImage ? "url(\"" + backgroundImage + "\")" : "";
    var backgroundCSS = "" + backgroundGradientCSS + backgroundColorCSS + backgroundImageCSS;
    return (theme_ui_1.jsx(theme_ui_1.Flex, { as: "article", "data-testid": exports.TEST_ID_ARTICLE, sx: __assign(__assign({ cursor: "pointer", flexDirection: "column", height: height + transformVertical + "px", justifyContent: "flex-end", marginRight: "-" + exports.articleOverlap + "px", width: exports.articleDefaultWidth + "px", ":hover > div": {
                transform: "translate(" + transformHorizontal + "px, -" + transformVertical + "px)"
            } }, articleStyleLookup[articlePosition]), csx), onClick: onClick },
        theme_ui_1.jsx(theme_ui_1.Flex, { sx: {
                background: backgroundCSS,
                backgroundSize: "cover",
                flexDirection: "column",
                height: height,
                justifyContent: "flex-end",
                px: 7,
                py: 3,
                transition: "transform 0.2s",
                width: width
            } }, children)));
}
exports.ArticleBase = ArticleBase;
